import { render, staticRenderFns } from "./LeadAktivitaetenListe.vue?vue&type=template&id=6164840e"
import script from "./LeadAktivitaetenListe.vue?vue&type=script&lang=js"
export * from "./LeadAktivitaetenListe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports